export default "__VITE_ASSET__6dbf13a4__"